import { __assign } from "tslib";
import React from 'react';
import Item from '../parts/item';
import { getItemProps } from './get-item-props';
export var renderOptions = function (_a) {
    var options = _a.options, getOptionProps = _a.getOptionProps, filteringValue = _a.filteringValue, _b = _a.isKeyboard, isKeyboard = _b === void 0 ? false : _b, _c = _a.checkboxes, checkboxes = _c === void 0 ? false : _c, hasDropdownStatus = _a.hasDropdownStatus, virtualItems = _a.virtualItems;
    return options.map(function (option, index) {
        var virtualItem = virtualItems && virtualItems[index];
        var globalIndex = virtualItem ? virtualItem.index : index;
        var props = getItemProps({
            option: option,
            index: globalIndex,
            getOptionProps: getOptionProps,
            filteringValue: filteringValue,
            isKeyboard: isKeyboard,
            checkboxes: checkboxes
        });
        var isLastItem = index === options.length - 1;
        var padBottom = !hasDropdownStatus && isLastItem;
        return (React.createElement(Item, __assign({ key: globalIndex }, props, { virtualPosition: virtualItem && virtualItem.start, ref: virtualItem && virtualItem.measureRef, padBottom: padBottom })));
    });
};
//# sourceMappingURL=render-options.js.map